import { render, staticRenderFns } from "./materialCate.vue?vue&type=template&id=dec611f8&scoped=true&"
import script from "./materialCate.vue?vue&type=script&lang=js&"
export * from "./materialCate.vue?vue&type=script&lang=js&"
import style0 from "./materialCate.vue?vue&type=style&index=0&id=dec611f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec611f8",
  null
  
)

export default component.exports